import clsx from "clsx";

import type { BoxProps } from "@/ui/atoms/Box";
import Box from "@/ui/atoms/Box";

export type LayoutBoxCenteredProps = BoxProps & {
    WrapperMainProps?: BoxProps;
    WrapperAboveProps?: BoxProps;
    contentAboveBox?: React.ReactNode;
};

const testId = "LayoutBoxCentered";
const LayoutBoxCentered = (props: LayoutBoxCenteredProps) => {
    const {
        sx,
        children,
        className,
        contentAboveBox,
        WrapperMainProps,
        WrapperAboveProps,
        ...otherProps
    } = props;

    return (
        <Box
            data-testid={testId}
            className={clsx([testId, className])}
            {...WrapperMainProps}
            sx={{
                width: "100%",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                ...WrapperMainProps?.sx,
            }}
        >
            {contentAboveBox !== undefined && (
                <Box {...WrapperAboveProps}>{contentAboveBox}</Box>
            )}
            <Box
                sx={{
                    width: "35%",
                    textAlign: "center",
                    margin: "10px auto",
                    border: "2px solid var(--light)",
                    borderRadius: "15px",
                    backgroundColor: "var(--proda-white)",
                    ...sx,
                }}
                {...otherProps}
            >
                {children}
            </Box>
        </Box>
    );
};

export default LayoutBoxCentered;
